export function parseUrl (url) {
  const parser = document.createElement('a');
  parser.href = url;
  return {
    host: parser.host,
    pathname: parser.pathname,
    url: parser.url
  };
}

export function hideHeader () { // hide header if em is in an iframe and parent frame has auryc
  try {
    return window.self !== window.top &&
      window['_auryc_is_inner_frame_'] !== true;
  } catch (e) {
    return (window['_auryc_is_inner_frame_'] !== true);
  }
};

export function getWinObject (frameNode) {
  let frameWindow;
  if (frameNode && frameNode.contentWindow) {
    frameWindow = frameNode.contentWindow;
  } else if (frameNode && frameNode.contentDocument && frameNode.contentDocument.defaultView) {
    frameWindow = frameNode.contentDocument.defaultView;
  }

  return (frameWindow && frameWindow !== frameWindow.top) ? frameWindow : null;
};



/** WEBPACK FOOTER **
 ** ./src/utils/url.js
 **/